import { LoginReducer, loginInitialState } from "./LoginReducer"
import {commonReducer,commonInitialState} from "./CommonReducer"
import combineReducers from 'react-combine-reducers';
export const [globalReducer, initialGlobal] = combineReducers({
    login: [LoginReducer, loginInitialState],
    common : [commonReducer, commonInitialState]
});